export const ACTIONS = {

  FORM_BRAND_SELECT: "FORM_BRAND_SELECT",

  TRANSITION_MAIN_INPUT: "TRANSITION_MAIN_INPUT",


  INPUT_FONT_FAMILY_CHANGE: "INPUT_FONT_FAMILY_CHANGE",

  FIELD_TOP_SPACING_DECREMENT: "FIELD_TOP_SPACING_DECREMENT",
  FIELD_TOP_SPACING_INCREMENT: "FIELD_TOP_SPACING_INCREMENT",
  FIELD_TOP_SPACING_INPUT: "FIELD_TOP_SPACING_INPUT",

  INPUT_HEIGHT_DECREMENT: "INPUT_HEIGHT_DECREMENT",
  INPUT_HEIGHT_INCREMENT: "INPUT_HEIGHT_INCREMENT",
  INPUT_HEIGHT_INPUT: "INPUT_HEIGHT_INPUT",

  INPUT_WIDTH_DECREMENT: "INPUT_WIDTH_DECREMENT",
  INPUT_WIDTH_INCREMENT: "INPUT_WIDTH_INCREMENT",
  INPUT_WIDTH_INPUT: "INPUT_WIDTH_INPUT",

  INPUT_WIDTH_UNITS: "INPUT_WIDTH_UNITS",

  INPUT_INLINE_PADDING_DECREMENT: "INPUT_INLINE_PADDING_DECREMENT",
  INPUT_INLINE_PADDING_INCREMENT: "INPUT_INLINE_PADDING_INCREMENT",
  INPUT_INLINE_PADDING_INPUT: "INPUT_INLINE_PADDING_INPUT",

  INPUT_BORDER_WIDTH_DECREMENT: "INPUT_BORDER_WIDTH_DECREMENT",
  INPUT_BORDER_WIDTH_INCREMENT: "INPUT_BORDER_WIDTH_INCREMENT",
  INPUT_BORDER_WIDTH_INPUT: "INPUT_BORDER_WIDTH_INPUT",

  INPUT_BORDER_COLOR_INPUT: "INPUT_BORDER_COLOR_INPUT",

  INPUT_TOGGLE_BORDER_STYLE: "INPUT_TOGGLE_BORDER_STYLE",

  INPUT_BORDER_RADIUS_DECREMENT: "INPUT_BORDER_RADIUS_DECREMENT",
  INPUT_BORDER_RADIUS_INCREMENT: "INPUT_BORDER_RADIUS_INCREMENT",
  INPUT_BORDER_RADIUS_INPUT: "INPUT_BORDER_RADIUS_INPUT",

  INPUT_FONT_SIZE_DECREMENT: "INPUT_FONT_SIZE_DECREMENT",
  INPUT_FONT_SIZE_INCREMENT: "INPUT_FONT_SIZE_INCREMENT",
  INPUT_FONT_SIZE_INPUT: "INPUT_FONT_SIZE_INPUT",

  INPUT_FONT_WEIGHT_INPUT: "INPUT_FONT_WEIGHT_INPUT",
  INPUT_FONT_FAMILY_INPUT: "INPUT_FONT_FAMILY_INPUT",

  INPUT_COLOR_INPUT: "INPUT_COLOR_INPUT",
  INPUT_BACKGROUND_INPUT: "INPUT_BACKGROUND_INPUT",

  INPUT_HOVER_COLOR_INPUT: "INPUT_HOVER_COLOR_INPUT",
  INPUT_HOVER_BACKGROUND_INPUT: "INPUT_HOVER_BACKGROUND_INPUT",
  INPUT_HOVER_BORDER_COLOR_INPUT: "INPUT_HOVER_BORDER_COLOR_INPUT",

  SELECT_FONT_FAMILY_CHANGE: "SELECT_FONT_FAMILY_CHANGE",

  SELECT_TOP_SPACING_DECREMENT: "SELECT_TOP_SPACING_DECREMENT",
  SELECT_TOP_SPACING_INCREMENT: "SELECT_TOP_SPACING_INCREMENT",
  SELECT_TOP_SPACING_INPUT: "SELECT_TOP_SPACING_INPUT",

  SELECT_HEIGHT_DECREMENT: "SELECT_HEIGHT_DECREMENT",
  SELECT_HEIGHT_INCREMENT: "SELECT_HEIGHT_INCREMENT",
  SELECT_HEIGHT_INPUT: "SELECT_HEIGHT_INPUT",

  SELECT_WIDTH_DECREMENT: "SELECT_WIDTH_DECREMENT",
  SELECT_WIDTH_INCREMENT: "SELECT_WIDTH_INCREMENT",
  SELECT_WIDTH_INPUT: "SELECT_WIDTH_INPUT",

  SELECT_WIDTH_UNITS: "SELECT_WIDTH_UNITS",

  SELECT_INLINE_PADDING_DECREMENT: "SELECT_INLINE_PADDING_DECREMENT",
  SELECT_INLINE_PADDING_INCREMENT: "SELECT_INLINE_PADDING_INCREMENT",
  SELECT_INLINE_PADDING_INPUT: "SELECT_INLINE_PADDING_INPUT",

  SELECT_BORDER_WIDTH_DECREMENT: "SELECT_BORDER_WIDTH_DECREMENT",
  SELECT_BORDER_WIDTH_INCREMENT: "SELECT_BORDER_WIDTH_INCREMENT",
  SELECT_BORDER_WIDTH_INPUT: "SELECT_BORDER_WIDTH_INPUT",

  SELECT_BORDER_COLOR_INPUT: "SELECT_BORDER_COLOR_INPUT",

  SELECT_TOGGLE_BORDER_STYLE: "SELECT_TOGGLE_BORDER_STYLE",

  SELECT_BORDER_RADIUS_DECREMENT: "SELECT_BORDER_RADIUS_DECREMENT",
  SELECT_BORDER_RADIUS_INCREMENT: "SELECT_BORDER_RADIUS_INCREMENT",
  SELECT_BORDER_RADIUS_INPUT: "SELECT_BORDER_RADIUS_INPUT",

  SELECT_FONT_SIZE_DECREMENT: "SELECT_FONT_SIZE_DECREMENT",
  SELECT_FONT_SIZE_INCREMENT: "SELECT_FONT_SIZE_INCREMENT",
  SELECT_FONT_SIZE_INPUT: "SELECT_FONT_SIZE_INPUT",

  SELECT_FONT_WEIGHT_INPUT: "SELECT_FONT_WEIGHT_INPUT",
  SELECT_FONT_FAMILY_INPUT: "SELECT_FONT_FAMILY_INPUT",

  SELECT_COLOR_INPUT: "SELECT_COLOR_INPUT",
  SELECT_BACKGROUND_INPUT: "SELECT_BACKGROUND_INPUT",

  SELECT_HOVER_COLOR_INPUT: "SELECT_HOVER_COLOR_INPUT",
  SELECT_HOVER_BACKGROUND_INPUT: "SELECT_HOVER_BACKGROUND_INPUT",
  SELECT_HOVER_BORDER_COLOR_INPUT: "SELECT_HOVER_BORDER_COLOR_INPUT",

  SELECT_TOGGLE_BACKGROUND_IMAGE: "SELECT_TOGGLE_BACKGROUND_IMAGE",
  SELECT_BACKGROUND_IMAGE_INPUT: "SELECT_BACKGROUND_IMAGE_INPUT",
  SELECT_BACKGROUND_IMAGE_SIZE_INPUT: "SELECT_BACKGROUND_IMAGE_SIZE_INPUT",
  SELECT_BACKGROUND_IMAGE_SIZE_DECREMENT: "SELECT_BACKGROUND_IMAGE_SIZE_DECREMENT",
  SELECT_BACKGROUND_IMAGE_SIZE_INCREMENT: "SELECT_BACKGROUND_IMAGE_SIZE_INCREMENT",
  SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_INPUT: "SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_INPUT",
  SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_DECREMENT: "SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_DECREMENT",
  SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_INCREMENT: "SELECT_BACKGROUND_IMAGE_POSITION_RIGHT_INCREMENT",


  TEXTAREA_FONT_FAMILY_CHANGE: "TEXTAREA_FONT_FAMILY_CHANGE",

  TEXTAREA_TOP_SPACING_DECREMENT: "TEXTAREA_TOP_SPACING_DECREMENT",
  TEXTAREA_TOP_SPACING_INCREMENT: "TEXTAREA_TOP_SPACING_INCREMENT",
  TEXTAREA_TOP_SPACING_INPUT: "TEXTAREA_TOP_SPACING_INPUT",

  TEXTAREA_HEIGHT_DECREMENT: "TEXTAREA_HEIGHT_DECREMENT",
  TEXTAREA_HEIGHT_INCREMENT: "TEXTAREA_HEIGHT_INCREMENT",
  TEXTAREA_HEIGHT_INPUT: "TEXTAREA_HEIGHT_INPUT",

  TEXTAREA_WIDTH_DECREMENT: "TEXTAREA_WIDTH_DECREMENT",
  TEXTAREA_WIDTH_INCREMENT: "TEXTAREA_WIDTH_INCREMENT",
  TEXTAREA_WIDTH_INPUT: "TEXTAREA_WIDTH_INPUT",

  TEXTAREA_WIDTH_UNITS: "TEXTAREA_WIDTH_UNITS",

  TEXTAREA_INLINE_PADDING_DECREMENT: "TEXTAREA_INLINE_PADDING_DECREMENT",
  TEXTAREA_INLINE_PADDING_INCREMENT: "TEXTAREA_INLINE_PADDING_INCREMENT",
  TEXTAREA_INLINE_PADDING_INPUT: "TEXTAREA_INLINE_PADDING_INPUT",

  TEXTAREA_BORDER_WIDTH_DECREMENT: "TEXTAREA_BORDER_WIDTH_DECREMENT",
  TEXTAREA_BORDER_WIDTH_INCREMENT: "TEXTAREA_BORDER_WIDTH_INCREMENT",
  TEXTAREA_BORDER_WIDTH_INPUT: "TEXTAREA_BORDER_WIDTH_INPUT",

  TEXTAREA_BORDER_COLOR_INPUT: "TEXTAREA_BORDER_COLOR_INPUT",

  TEXTAREA_TOGGLE_BORDER_STYLE: "TEXTAREA_TOGGLE_BORDER_STYLE",

  TEXTAREA_BORDER_RADIUS_DECREMENT: "TEXTAREA_BORDER_RADIUS_DECREMENT",
  TEXTAREA_BORDER_RADIUS_INCREMENT: "TEXTAREA_BORDER_RADIUS_INCREMENT",
  TEXTAREA_BORDER_RADIUS_INPUT: "TEXTAREA_BORDER_RADIUS_INPUT",

  TEXTAREA_FONT_SIZE_DECREMENT: "TEXTAREA_FONT_SIZE_DECREMENT",
  TEXTAREA_FONT_SIZE_INCREMENT: "TEXTAREA_FONT_SIZE_INCREMENT",
  TEXTAREA_FONT_SIZE_INPUT: "TEXTAREA_FONT_SIZE_INPUT",

  TEXTAREA_FONT_WEIGHT_INPUT: "TEXTAREA_FONT_WEIGHT_INPUT",
  TEXTAREA_FONT_FAMILY_INPUT: "TEXTAREA_FONT_FAMILY_INPUT",

  TEXTAREA_COLOR_INPUT: "TEXTAREA_COLOR_INPUT",
  TEXTAREA_BACKGROUND_INPUT: "TEXTAREA_BACKGROUND_INPUT",

  TEXTAREA_HOVER_COLOR_INPUT: "TEXTAREA_HOVER_COLOR_INPUT",
  TEXTAREA_HOVER_BACKGROUND_INPUT: "TEXTAREA_HOVER_BACKGROUND_INPUT",
  TEXTAREA_HOVER_BORDER_COLOR_INPUT: "TEXTAREA_HOVER_BORDER_COLOR_INPUT",

  FIELD_LABEL_FONT_FAMILY_CHANGE: "FIELD_LABEL_FONT_FAMILY_CHANGE",

  FIELD_LABEL_FONT_SIZE_DECREMENT: "FIELD_LABEL_FONT_SIZE_DECREMENT",
  FIELD_LABEL_FONT_SIZE_INCREMENT: "FIELD_LABEL_FONT_SIZE_INCREMENT",
  FIELD_LABEL_FONT_SIZE_INPUT: "FIELD_LABEL_FONT_SIZE_INPUT",

  FIELD_LABEL_FONT_WEIGHT_INPUT: "FIELD_LABEL_FONT_WEIGHT_INPUT",

  FIELD_LABEL_BOTTOM_SPACING_DECREMENT: "FIELD_LABEL_BOTTOM_SPACING_DECREMENT",
  FIELD_LABEL_BOTTOM_SPACING_INCREMENT: "FIELD_LABEL_BOTTOM_SPACING_INCREMENT",
  FIELD_LABEL_BOTTOM_SPACING_INPUT: "FIELD_LABEL_BOTTOM_SPACING_INPUT",

  FIELD_LABEL_PADDING_DECREMENT: "FIELD_LABEL_PADDING_DECREMENT",
  FIELD_LABEL_PADDING_INCREMENT: "FIELD_LABEL_PADDING_INCREMENT",
  FIELD_LABEL_PADDING_INPUT: "FIELD_LABEL_PADDING_INPUT",

  FIELD_LABEL_COLOR_INPUT: "FIELD_LABEL_COLOR_INPUT",
  FIELD_LABEL_COLOR_ASTERISK: "FIELD_LABEL_COLOR_ASTERISK",

  FIELD_LABEL_ALIGNMENT: "FIELD_LABEL_ALIGNMENT",

  TOGGLE_FIELD_LABEL: "TOGGLE_FIELD_LABEL",

  DESCRIPTION_FONT_FAMILY_CHANGE: "DESCRIPTION_FONT_FAMILY_CHANGE",

  DESCRIPTION_TOP_SPACING_DECREMENT: "DESCRIPTION_SPACING_DECREMENT",
  DESCRIPTION_TOP_SPACING_INCREMENT: "DESCRIPTION_TOP_SPACING_INCREMENT",
  DESCRIPTION_TOP_SPACING_INPUT: "DESCRIPTION_TOP_SPACING_INPUT",

  DESCRIPTION_INLINE_PADDING_DECREMENT: "DESCRIPTION_INLINE_PADDING_DECREMENT",
  DESCRIPTION_INLINE_PADDING_INCREMENT: "DESCRIPTION_INLINE_PADDING_INCREMENT",
  DESCRIPTION_INLINE_PADDING_INPUT: "DESCRIPTION_INLINE_PADDING_INPUT",

  DESCRIPTION_FONT_SIZE_DECREMENT: "DESCRIPTION_FONT_SIZE_DECREMENT",
  DESCRIPTION_FONT_SIZE_INCREMENT: "DESCRIPTION_FONT_SIZE_INCREMENT",
  DESCRIPTION_FONT_SIZE_INPUT: "DESCRIPTION_FONT_SIZE_INPUT",

  DESCRIPTION_FONT_WEIGHT_INPUT: "DESCRIPTION_FONT_WEIGHT_INPUT",

  DESCRIPTION_COLOR_INPUT: "DESCRIPTION_COLOR_INPUT",

  TOGGLE_DESCRIPTION: "TOGGLE_DESCRIPTION",
  TOGGLE_DESCRIPTION_CONTENT: "TOGGLE_DESCRIPTION_CONTENT",

  PLACEHOLDER_FONT_FAMILY_CHANGE: "PLACEHOLDER_FONT_FAMILY_CHANGE",

  PLACEHOLDER_COLOR_INPUT: "PLACEHOLDER_COLOR_INPUT",
  PLACEHOLDER_HOVER_COLOR_INPUT: "PLACEHOLDER_HOVER_COLOR_INPUT",
  PLACEHOLDER_FONT_FAMILY_INPUT: "PLACEHOLDER_FONT_FAMILY_INPUT",
  PLACEHOLDER_FONT_WEIGHT_INPUT: "PLACEHOLDER_FONT_WEIGHT_INPUT",

  PLACEHOLDER_FONT_SIZE_DECREMENT: "PLACEHOLDER_FONT_SIZE_DECREMENT",
  PLACEHOLDER_FONT_SIZE_INCREMENT: "PLACEHOLDER_FONT_SIZE_INCREMENT",
  PLACEHOLDER_FONT_SIZE_INPUT: "PLACEHOLDER_FONT_SIZE_INPUT",

  TOGGLE_PLACEHOLDERS: "TOGGLE_PLACEHOLDERS",

  TOGGLE_CHECKBOX: "TOGGLE_CHECKBOX",

  CHECKBOX_INPUT_SIZE_INPUT: "CHECKBOX_INPUT_SIZE_INPUT",
  CHECKBOX_INPUT_SIZE_DECREMENT: "CHECKBOX_INPUT_SIZE_DECREMENT",
  CHECKBOX_INPUT_SIZE_INCREMENT: "CHECKBOX_INPUT_SIZE_INCREMENT",

  CHECKBOX_BORDER_WIDTH_INPUT: "CHECKBOX_BORDER_WIDTH_INPUT",
  CHECKBOX_BORDER_WIDTH_DECREMENT: "CHECKBOX_BORDER_WIDTH_DECREMENT",
  CHECKBOX_BORDER_WIDTH_INCREMENT: "CHECKBOX_BORDER_WIDTH_INCREMENT",

  CHECKBOX_BORDER_RADIUS_INPUT: "CHECKBOX_BORDER_RADIUS_INPUT",
  CHECKBOX_BORDER_RADIUS_DECREMENT: "CHECKBOX_BORDER_RADIUS_DECREMENT",
  CHECKBOX_BORDER_RADIUS_INCREMENT: "CHECKBOX_BORDER_RADIUS_INCREMENT",

  CHECKBOX_UNCHECKED_BORDER_COLOR_INPUT:
    "CHECKBOX_UNCHECKED_BORDER_COLOR_INPUT",
  CHECKBOX_UNCHECKED_BACKGROUND_COLOR_INPUT:
    "CHECKBOX_UNCHECKED_BACKGROUND_COLOR_INPUT",
  CHECKBOX_CHECKED_BORDER_COLOR_INPUT: "CHECKBOX_CHECKED_BORDER_COLOR_INPUT",
  CHECKBOX_CHECKED_BACKGROUND_COLOR_INPUT:
    "CHECKBOX_CHECKED_BACKGROUND_COLOR_INPUT",
  CHECKBOX_CHECKED_COLOR_INPUT: "CHECKBOX_CHECKED_COLOR_INPUT",
  CHECKBOX_ALIGNMENT: "CHECKBOX_ALIGNMENT",

  TOGGLE_CHECKBOX_CONTENT: "TOGGLE_CHECKBOX_CONTENT",

  CHECKBOX_LABEL_FONT_FAMILY_CHANGE: "CHECKBOX_LABEL_FONT_FAMILY_CHANGE",

  CHECKBOX_LABEL_FONT_SIZE_DECREMENT: "CHECKBOX_LABEL_FONT_SIZE_DECREMENT",
  CHECKBOX_LABEL_FONT_SIZE_INCREMENT: "CHECKBOX_LABEL_FONT_SIZE_INCREMENT",
  CHECKBOX_LABEL_FONT_SIZE_INPUT: "CHECKBOX_LABEL_FONT_SIZE_INPUT",

  CHECKBOX_LABEL_FONT_WEIGHT_INPUT: "CHECKBOX_LABEL_FONT_WEIGHT_INPUT",

  CHECKBOX_LABEL_COLOR_INPUT: "CHECKBOX_LABEL_COLOR_INPUT",

  TOGGLE_RADIO: "TOGGLE_RADIO",

  RADIO_INPUT_SIZE_INPUT: "RADIO_INPUT_SIZE_INPUT",
  RADIO_INPUT_SIZE_DECREMENT: "RADIO_INPUT_SIZE_DECREMENT",
  RADIO_INPUT_SIZE_INCREMENT: "RADIO_INPUT_SIZE_INCREMENT",

  RADIO_BORDER_WIDTH_INPUT: "RADIO_BORDER_WIDTH_INPUT",
  RADIO_BORDER_WIDTH_DECREMENT: "RADIO_BORDER_WIDTH_DECREMENT",
  RADIO_BORDER_WIDTH_INCREMENT: "RADIO_BORDER_WIDTH_INCREMENT",

  RADIO_BORDER_RADIUS_INPUT: "RADIO_BORDER_RADIUS_INPUT",
  RADIO_BORDER_RADIUS_DECREMENT: "RADIO_BORDER_RADIUS_DECREMENT",
  RADIO_BORDER_RADIUS_INCREMENT: "RADIO_BORDER_RADIUS_INCREMENT",

  RADIO_UNCHECKED_BORDER_COLOR_INPUT: "RADIO_UNCHECKED_BORDER_COLOR_INPUT",
  RADIO_UNCHECKED_BACKGROUND_COLOR_INPUT:
    "RADIO_UNCHECKED_BACKGROUND_COLOR_INPUT",
  RADIO_CHECKED_BORDER_COLOR_INPUT: "RADIO_CHECKED_BORDER_COLOR_INPUT",
  RADIO_CHECKED_BACKGROUND_COLOR_INPUT: "RADIO_CHECKED_BACKGROUND_COLOR_INPUT",

  RADIO_LABEL_FONT_FAMILY_CHANGE: "RADIO_LABEL_FONT_FAMILY_CHANGE",

  RADIO_LABEL_FONT_SIZE_DECREMENT: "RADIO_LABEL_FONT_SIZE_DECREMENT",
  RADIO_LABEL_FONT_SIZE_INCREMENT: "RADIO_LABEL_FONT_SIZE_INCREMENT",
  RADIO_LABEL_FONT_SIZE_INPUT: "RADIO_LABEL_FONT_SIZE_INPUT",

  RADIO_LABEL_FONT_WEIGHT_INPUT: "RADIO_LABEL_FONT_WEIGHT_INPUT",

  RADIO_LABEL_COLOR_INPUT: "RADIO_LABEL_COLOR_INPUT",

  TOGGLE_TOGGLE: "TOGGLE_TOGGLE",
  TOGGLE_PADDING: "TOGGLE_PADDING",
  TOGGLE_PADDING_INCREMENT: "TOGGLE_PADDING_INCREMENT",
  TOGGLE_PADDING_DECREMENT: "TOGGLE_PADDING_DECREMENT",
  TOGGLE_MARGIN_BOTTOM: "TOGGLE_MARGIN_BOTTOM",
  TOGGLE_MARGIN_BOTTOM_INCREMENT: "TOGGLE_MARGIN_BOTTOM_INCREMENT",
  TOGGLE_MARGIN_BOTTOM_DECREMENT: "TOGGLE_MARGIN_BOTTOM_DECREMENT",
  TOGGLE_POSITION: "TOGGLE_POSITION",
  TOGGLE_WIDTH: "TOGGLE_WIDTH",
  TOGGLE_WIDTH_INCREMENT: "TOGGLE_WIDTH_INCREMENT",
  TOGGLE_WIDTH_DECREMENT: "TOGGLE_WIDTH_DECREMENT",
  TOGGLE_HEIGHT: "TOGGLE_HEIGHT",
  TOGGLE_HEIGHT_INCREMENT: "TOGGLE_HEIGHT_INCREMENT",
  TOGGLE_HEIGHT_DECREMENT: "TOGGLE_HEIGHT_DECREMENT",
  TOGGLE_BACKGROUND_COLOR: "TOGGLE_BACKGROUND_COLOR",
  TOGGLE_CHECKED_BACKGROUND_COLOR: "TOGGLE_CHECKED_BACKGROUND_COLOR",
  TOGGLE_BORDER_WIDTH: "TOGGLE_BORDER_WIDTH",
  TOGGLE_BORDER_WIDTH_INCREMENT: "TOGGLE_BORDER_WIDTH_INCREMENT",
  TOGGLE_BORDER_WIDTH_DECREMENT: "TOGGLE_BORDER_WIDTH_DECREMENT",
  TOGGLE_BORDER_COLOR: "TOGGLE_BORDER_COLOR",
  TOGGLE_BORDER_RADIUS: "TOGGLE_BORDER_RADIUS",
  TOGGLE_BORDER_RADIUS_INCREMENT: "TOGGLE_BORDER_RADIUS_INCREMENT",
  TOGGLE_BORDER_RADIUS_DECREMENT: "TOGGLE_BORDER_RADIUS_DECREMENT",
  TOGGLE_MARGIN_RIGHT: "TOGGLE_MARGIN_RIGHT",
  TOGGLE_MARGIN_RIGHT_INCREMENT: "TOGGLE_MARGIN_RIGHT_INCREMENT",
  TOGGLE_MARGIN_RIGHT_DECREMENT: "TOGGLE_MARGIN_RIGHT_DECREMENT",
  TOGGLE_KNOB_WIDTH: "TOGGLE_KNOB_WIDTH",
  TOGGLE_KNOB_WIDTH_INCREMENT: "TOGGLE_KNOB_WIDTH_INCREMENT",
  TOGGLE_KNOB_WIDTH_DECREMENT: "TOGGLE_KNOB_WIDTH_DECREMENT",
  TOGGLE_KNOB_HEIGHT: "TOGGLE_KNOB_HEIGHT",
  TOGGLE_KNOB_HEIGHT_INCREMENT: "TOGGLE_KNOB_HEIGHT_INCREMENT",
  TOGGLE_KNOB_HEIGHT_DECREMENT: "TOGGLE_KNOB_HEIGHT_DECREMENT",
  TOGGLE_KNOB_COLOR: "TOGGLE_KNOB_COLOR",
  TOGGLE_KNOB_ALIGNMENT: "TOGGLE_KNOB_ALIGNMENT",
  TOGGLE_KNOB_ALIGNMENT_INCREMENT: "TOGGLE_KNOB_ALIGNMENT_INCREMENT",
  TOGGLE_KNOB_ALIGNMENT_DECREMENT: "TOGGLE_KNOB_ALIGNMENT_DECREMENT",
  TOGGLE_KNOB_CHECKED_COLOR: "TOGGLE_KNOB_CHECKED_COLOR",
  TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT: "TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT",
  TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT_INCREMENT: "TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT_INCREMENT",
  TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT_DECREMENT: "TOGGLE_KNOB_CHECKED_ALIGNMENT_LEFT_DECREMENT",
  TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP: "TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP",
  TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP_INCREMENT: "TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP_INCREMENT",
  TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP_DECREMENT: "TOGGLE_KNOB_CHECKED_ALIGNMENT_TOP_DECREMENT",
  TOGGLE_LABEL_FONT_FAMILY_CHANGE: "TOGGLE_LABEL_FONT_FAMILY_CHANGE",
  TOGGLE_LABEL_FONT_SIZE_DECREMENT: "TOGGLE_LABEL_FONT_SIZE_DECREMENT",
  TOGGLE_LABEL_FONT_SIZE_INCREMENT: "TOGGLE_LABEL_FONT_SIZE_INCREMENT",
  TOGGLE_LABEL_FONT_SIZE_INPUT: "TOGGLE_LABEL_FONT_SIZE_INPUT",
  TOGGLE_LABEL_FONT_WEIGHT_INPUT: "TOGGLE_LABEL_FONT_WEIGHT_INPUT",
  TOGGLE_LABEL_COLOR_INPUT: "TOGGLE_LABEL_COLOR_INPUT",

  SUBMIT_FONT_FAMILY_CHANGE: "SUBMIT_FONT_FAMILY_CHANGE",

  SUBMIT_MARGIN_TOP_INPUT: "SUBMIT_MARGIN_TOP_INPUT",
  SUBMIT_MARGIN_TOP_DECREMENT: "SUBMIT_MARGIN_TOP_DECREMENT",
  SUBMIT_MARGIN_TOP_INCREMENT: "SUBMIT_MARGIN_TOP_INCREMENT",

  SUBMIT_FONT_SIZE_INPUT: "SUBMIT_FONT_SIZE_INPUT",
  SUBMIT_FONT_SIZE_DECREMENT: "SUBMIT_FONT_SIZE_DECREMENT",
  SUBMIT_FONT_SIZE_INCREMENT: "SUBMIT_FONT_SIZE_INCREMENT",

  SUBMIT_FONT_FAMILY_INPUT: "SUBMIT_FONT_FAMILY_INPUT",

  SUBMIT_WIDTH_INPUT: "SUBMIT_WIDTH_INPUT",
  SUBMIT_WIDTH_DECREMENT: "SUBMIT_WIDTH_DECREMENT",
  SUBMIT_WIDTH_INCREMENT: "SUBMIT_WIDTH_INCREMENT",

  SUBMIT_HEIGHT_INPUT: "SUBMIT_HEIGHT_INPUT",
  SUBMIT_HEIGHT_DECREMENT: "SUBMIT_HEIGHT_DECREMENT",
  SUBMIT_HEIGHT_INCREMENT: "SUBMIT_HEIGHT_INCREMENT",

  SUBMIT_BORDER_RADIUS_INPUT: "SUBMIT_BORDER_RADIUS_INPUT",
  SUBMIT_BORDER_RADIUS_DECREMENT: "SUBMIT_BORDER_RADIUS_DECREMENT",
  SUBMIT_BORDER_RADIUS_INCREMENT: "SUBMIT_BORDER_RADIUS_INCREMENT",

  SUBMIT_BORDER_WIDTH_INPUT: "SUBMIT_BORDER_WIDTH_INPUT",
  SUBMIT_BORDER_WIDTH_DECREMENT: "SUBMIT_BORDER_WIDTH_DECREMENT",
  SUBMIT_BORDER_WIDTH_INCREMENT: "SUBMIT_BORDER_WIDTH_INCREMENT",

  SUBMIT_WIDTH_UNITS: "SUBMIT_WIDTH_UNITS",

  SUBMIT_BACKGROUND_INPUT: "SUBMIT_BACKGROUND_INPUT",
  SUBMIT_COLOR_INPUT: "SUBMIT_COLOR_INPUT",
  SUBMIT_BORDER_COLOR_INPUT: "SUBMIT_BORDER_COLOR_INPUT",

  SUBMIT_BACKGROUND_HOVER_INPUT: "SUBMIT_BACKGROUND_HOVER_INPUT",
  SUBMIT_COLOR_HOVER_INPUT: "SUBMIT_COLOR_HOVER_INPUT",
  SUBMIT_BORDER_COLOR_HOVER_INPUT: "SUBMIT_BORDER_COLOR_HOVER_INPUT",
  SUBMIT_TEXT_ALIGN_INPUT: "SUBMIT_TEXT_ALIGN_INPUT",
  SUBMIT_TEXT_INPUT: "SUBMIT_TEXT_INPUT",
  SUBMIT_FONT_WEIGHT_INPUT: "SUBMIT_FONT_WEIGHT_INPUT",

  SUBMIT_BACKGROUND_IMAGE_INPUT: "SUBMIT_BACKGROUND_IMAGE_INPUT",

  SUBMIT_BACKGROUND_IMAGE_SIZE_INPUT: "SUBMIT_BACKGROUND_IMAGE_SIZE_INPUT",
  SUBMIT_BACKGROUND_IMAGE_SIZE_DECREMENT:
    "SUBMIT_BACKGROUND_IMAGE_SIZE_DECREMENT",
  SUBMIT_BACKGROUND_IMAGE_SIZE_INCREMENT:
    "SUBMIT_BACKGROUND_IMAGE_SIZE_INCREMENT",

  SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_INPUT:
    "SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_NPUT",
  SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_DECREMENT:
    "SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_DECREMENT",
  SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_INCREMENT:
    "SUBMIT_BACKGROUND_IMAGE_POSITION_RIGHT_INCREMENT",

  SUBMIT_BUTTON_ALIGN_INPUT: "SUBMIT_BUTTON_ALIGN_INPUT",

  SUBMIT_TOGGLE_BACKGROUND_IMAGE: "SUBMIT_TOGGLE_BACKGROUND_IMAGE",

  TOGGLE_ERRORS: "TOGGLE_ERRORS",

  ERRORTEXT_FONT_FAMILY_CHANGE: "ERRORTEXT_FONT_FAMILY_CHANGE",
  ERRORTEXT_FONT_FAMILY_INPUT: "ERRORTEXT_FONT_FAMILY_INPUT",

  ERRORTEXT_FONT_SIZE_INPUT: "ERRORTEXT_FONT_SIZE_INPUT",
  ERRORTEXT_FONT_SIZE_DECREMENT: "ERRORTEXT_FONT_SIZE_DECREMENT",
  ERRORTEXT_FONT_SIZE_INCREMENT: "ERRORTEXT_FONT_SIZE_INCREMENT",

  ERRORTEXT_COLOR: "ERRORTEXT_COLOR",

  ERRORTEXT_FONT_WEIGHT_INPUT: "ERRORTEXT_FONT_WEIGHT_INPUT",

  ERRORTEXT_TOP_SPACING_DECREMENT: "ERRORTEXT_TOP_SPACING_DECREMENT",
  ERRORTEXT_TOP_SPACING_INCREMENT: "ERRORTEXT_TOP_SPACING_INCREMENT",
  ERRORTEXT_TOP_SPACING_INPUT: "ERRORTEXT_TOP_SPACING_INPUT",

  ERRORTEXT_INLINE_PADDING_DECREMENT: "ERRORTEXT_INLINE_PADDING_DECREMENT",
  ERRORTEXT_INLINE_PADDING_INCREMENT: "ERRORTEXT_INLINE_PADDING_INCREMENT",
  ERRORTEXT_INLINE_PADDING_INPUT: "ERRORTEXT_INLINE_PADDING_INPUT",

  ERRORHEAD_FONT_FAMILY_CHANGE: "ERRORHEAD_FONT_FAMILY_CHANGE",
  ERRORHEAD_FONT_FAMILY_INPUT: "ERRORHEAD_FONT_FAMILY_INPUT",

  ERRORHEAD_FONT_SIZE_INPUT: "ERRORHEAD_FONT_SIZE_INPUT",
  ERRORHEAD_FONT_SIZE_DECREMENT: "ERRORHEAD_FONT_SIZE_DECREMENT",
  ERRORHEAD_FONT_SIZE_INCREMENT: "ERRORHEAD_FONT_SIZE_INCREMENT",

  ERRORHEAD_COLOR: "ERRORHEAD_COLOR",

  ERRORHEAD_FONT_WEIGHT_INPUT: "ERRORHEAD_FONT_WEIGHT_INPUT",

  ERRORHEAD_BOTTOM_SPACING_DECREMENT: "ERRORHEAD_BOTTOM_SPACING_DECREMENT",
  ERRORHEAD_BOTTOM_SPACING_INCREMENT: "ERRORHEAD_BOTTOM_SPACING_INCREMENT",
  ERRORHEAD_BOTTOM_SPACING_INPUT: "ERRORHEAD_BOTTOM_SPACING_INPUT",

  ERRORHEAD_INLINE_PADDING_DECREMENT: "ERRORHEAD_INLINE_PADDING_DECREMENT",
  ERRORHEAD_INLINE_PADDING_INCREMENT: "ERRORHEAD_INLINE_PADDING_INCREMENT",
  ERRORHEAD_INLINE_PADDING_INPUT: "ERRORHEAD_INLINE_PADDING_INPUT",

  ERRORHEAD_BACKGROUND_COLOR: "ERRORHEAD_BACKGROUND_COLOR",

};
